import React from 'react';
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class LinkButton extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {

        const {
            className, text, link, color, type, tab, ...props
        } = this.props;

        let [
            btnTypeClasses, renderBtn
        ] = ''

        if (color === 'gray') {
            btnTypeClasses = 'btn-gray tw-bg-gray-400 tw-text-gray-700'
        }
        if (color === 'gray-dark') {
            btnTypeClasses = 'btn-gray-dark tw-bg-gray-700 tw-text-white'
        }

        if (color === 'orange') {
            btnTypeClasses = 'btn-orange tw-bg-orange-400 tw-text-white'
        }

        const finalClassName = `btn tw-text-center tw-uppercase font-sp tw-py-4 tw-px-8 tw-mx-auto tw-inline-block ${btnTypeClasses} ${className}`;

        renderBtn =
            <Link
                target={tab}
                to={link}
                {...props}
                className={finalClassName}>
                {text}
            </Link>


        return (
            <div>
                {renderBtn}
            </div>
        );
    }
}

LinkButton.defaultProps = {
    tab: ''
};

LinkButton.propTypes = {
    className: PropTypes.string,
    text: PropTypes.node.isRequired,
    link: PropTypes.string,
    color: PropTypes.string,
    type: PropTypes.string,
    tab: PropTypes.string
};

export default LinkButton;
